import React from "react";

function WhyMore() {
  return (
    <section className="hm-block hm-quote">
      <div className="hm-wrap">
        <blockquote className="hm-reveal">Baro Mase Tero Parban</blockquote>
        <p className="hm-quote-tr hm-reveal">
          Thirteen festivals in twelve months. Bengal has always been a land of festivals — and
          far from our roots, in Bangalore, SORRBA keeps the tradition alive: a platform for
          every member to showcase their talent, run with the highest standard of ethics,
          transparency and full statutory compliance.
        </p>
      </div>
    </section>
  );
}

export default WhyMore;
